import React from 'react';
import styled from 'styled-components';
import { initArrayOfLength } from '../_utils/array';
import { LoadingSkeleton } from '../LoadingSkeleton';
import { Stack } from '../Stack';
export const LoadingSkeletonLogoAndText = ({ numberOfTextRows = 2, imagePlaceholderSize = '32px', gap = '1.6rem', }) => {
    const skeletonArray = initArrayOfLength(numberOfTextRows);
    return (React.createElement(Stack, { alignItems: "center", flexDirection: "row", gap: gap },
        React.createElement(LoadingSkeleton, { width: imagePlaceholderSize, height: imagePlaceholderSize }),
        React.createElement(StyledInnerStack, { gap: "0" }, skeletonArray.map((i) => (React.createElement(LoadingSkeleton, { variant: "body1", key: i }))))));
};
const StyledInnerStack = styled(Stack) `
  flex-grow: 1;
`;
